module.exports = __webpack_public_path__ + "static/media/bed-symbolic.31748078.png";